module.exports = __webpack_public_path__ + "static/media/pharos-logo-dark.a73e4798.webp";